
import * as actions from "@/AppRedux/actions/theme/themeType";
import { ThemeState, ThemeData } from "@/AppRedux/actions/theme/themeType";
import {
  themeDefault,
  themePastelMint,
  themePastelLavender,
  themePastelPeach,
  themePastelOcean,
  themeLightPastel,
  themeDarkPastel,
  themeSunsetOrange,
  themeMidnightDark,
  themeNatureGreen,
  themeLuxuryPurple,
  themeBoldRed,
  themeOceanTeal,
} from "@/AppRedux/sagas/theme/themeMockupTemplate";
import { createSelector } from "reselect";

export const themeOptions = [
  { label: "Default", value: "themeDefault", theme: themeDefault },
  { label: "Pastel Mint", value: "themePastelMint", theme: themePastelMint },
  {
    label: "Pastel Lavender",
    value: "themePastelLavender",
    theme: themePastelLavender,
  },
  { label: "Pastel Peach", value: "themePastelPeach", theme: themePastelPeach },
  { label: "Pastel Ocean", value: "themePastelOcean", theme: themePastelOcean },
  { label: "Light Pastel", value: "themeLightPastel", theme: themeLightPastel },
  { label: "Dark Pastel", value: "themeDarkPastel", theme: themeDarkPastel },
  {
    label: "Sunset Orange",
    value: "themeSunsetOrange",
    theme: themeSunsetOrange,
  },
  {
    label: "Midnight Dark",
    value: "themeMidnightDark",
    theme: themeMidnightDark,
  },
  {
    label: "Nature Green",
    value: "themeNatureGreen",
    theme: themeNatureGreen,
  },
  {
    label: "Luxury Purple",
    value: "themeLuxuryPurple",
    theme: themeLuxuryPurple,
  },
  { label: "Bold Red", value: "themeBoldRed", theme: themeBoldRed },
  { label: "Ocean Teal", value: "themeOceanTeal", theme: themeOceanTeal },
];

const initialState: ThemeState = {
  loading: false,
  data: themeDefault as ThemeState["data"],
  error: null,
};

export default function themeReducer(
  state: ThemeState = initialState,
  action: actions.ThemeAction
): ThemeState {
  switch (action.type) {
    case actions.THEME_REQUEST:
      return { ...state, loading: true, error: null };
    case actions.THEME_SUCCESS:
      return {
        ...state,
        loading: false,
        data: { ...state.data, ...action.payload },
        error: null,
      };
    case actions.THEME_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case actions.SET_THEME:
      return {
        ...state,
        data: action.payload,
      };
    case actions.UPDATE_THEME:
      return {
        ...state,
        data: { ...state.data, ...action.payload },
      };
    case actions.UPDATE_THEME_TEMPLATE:
      return {
        ...state,
        data: action.payload,
      };
    case actions.SAVE_THEME_REQUEST:
      return { ...state, loading: true, error: null };
    case actions.SAVE_THEME_SUCCESS:
      return { ...state, loading: false, error: null };
    case actions.SAVE_THEME_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}

const selectThemeState = (state: { theme: ThemeState }) => state.theme;

export const themeSelector = createSelector(selectThemeState,(themeState) => themeState.data);

export const themeOptionsSelector = createSelector(() => themeOptions,(options) => options);
